export default __webpack_public_path__ + "e21a7d34a8d3c0bb8330d42ecf45369c.png";